import React, { useState, useEffect } from 'react';

import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import schema from './leaderboardJsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../../common/functions/useTableGenerator';
import ClassService from './ClassService';

const LeaderboardTable = () => {
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();
  const [refreshList, setRefreshList] = useState(false);

  const convertTime = time => {
    const date = new Date(time);
    return date.toLocaleDateString();
  };


  const jsonSchema = schema;

  useEffect(() => {
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    ClassService.retrieveleaderboard()
      .then(data => {
        const updatedData = data;

        const actionButtons = [
        ];

        setNoDataToShow(updatedData.length === 0);
        setTableGenerated(useTableGenerator(updatedData, jsonSchema, actionButtons));
        setRefreshList(false);
      })
      .catch(error => setError(error.message));
  }, [refreshList]);

  const buttonsConf = [];
  const headerGenerated = useHeaderGenerator('Leaderboard', ' ', buttonsConf);

  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Leaderboard to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default LeaderboardTable;